/**
 * @class MultiFacilityParser
 * @description parses the { "Facility Name": { id } } map into
 * { facilityId, facilityName }[] consumed by AutoComplete/FacilityDetailHeader.
 */
var MultiFacilityParser = /** @class */ (function () {
    function MultiFacilityParser() {
    }
    MultiFacilityParser.prototype.parse = function (data) {
        if (data === void 0) { data = {}; }
        return Object.entries(data).map(function (_a) {
            var facilityName = _a[0], facility = _a[1];
            return ({
                facilityId: facility.id,
                facilityName: facilityName,
            });
        });
    };
    return MultiFacilityParser;
}());
export default MultiFacilityParser;
